import React, { useState } from "react";
import Events from "../components/Events";
import { FaPlus } from "react-icons/fa6";
import AddEvents from "../components/modals/AddEvents";
import EditEvent from "../components/modals/EditEvent";
import useEventState from "../hooks/eventHooks";
import ConfirmationModal from "../components/modals/ConfirmationModal";

function EventsPage() {
  const { events, getEvents, addEvent, updateEvent, deleteEvent } =
    useEventState();
  const [isAddEventModalOpen, setIsAddEventModalOpen] = useState(false);
  const [isEditEventModalOpen, setIsEditEventModalOpen] = useState(false);
  const [isConfimationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [id, setId] = useState();

  const [editEvent, setEditEvent] = useState({});
  return (
    <div className="p-7">
      <div className="flex justify-between items-center mb-10 mt-4 w-full">
        <h2 className="font-semibold text-2xl">Events</h2>
        <button
          onClick={() => {
            setIsAddEventModalOpen(true);
          }}
          className="flex justify-center items-center space-x-2 w-44 h-10 rounded-md bg-green-50 text-white"
        >
          <FaPlus />
          <p>Add New Event</p>
        </button>
      </div>

      <Events
        setIsEditEventModalOpen={setIsEditEventModalOpen}
        events={events}
        getEvents={getEvents}
        setEditEvent={setEditEvent}
        setIsConfirmationModalOpen={setIsConfirmationModalOpen}
        setId={setId}
      />
      {isAddEventModalOpen && (
        <AddEvents
          addEvent={addEvent}
          setIsAddEventModalOpen={setIsAddEventModalOpen}
        />
      )}
      {isEditEventModalOpen && (
        <EditEvent
          updateEvent={updateEvent}
          editEvent={editEvent}
          setIsEditEventModalOpen={setIsEditEventModalOpen}
        />
      )}
      {isConfimationModalOpen && (
        <ConfirmationModal
          deleteEvent={deleteEvent}
          setIsConfirmationModalOpen={setIsConfirmationModalOpen}
          id={id}
        />
      )}
    </div>
  );
}

export default EventsPage;
